import React from "react";
import { Modal, CloseButton } from "react-bootstrap";
import { CopyButton, truncateAddress } from "../shared";

const MCP_URL = "https://dev-api.horuswallet.com/mcp";

export default function KeyCreatedModal({ show, onClose, keyData }) {
  if (!keyData) return null;

  // Backend returns: key, name, prefix, wallet_index, wallet_address, ...
  const apiKey = keyData.key || keyData.apiKey;
  const name = keyData.name;
  const walletAddress = keyData.wallet_address || keyData.wallet?.address;
  const walletIndex = keyData.wallet_index ?? keyData.wallet?.walletIndex;

  const configJson = JSON.stringify(
    {
      mcpServers: {
        "horus-wallet": {
          url: MCP_URL,
          headers: {
            Authorization: `Bearer ${apiKey}`,
          },
        },
      },
    },
    null,
    2
  );

  return (
    <Modal
      show={show}
      onHide={() => {}}
      size="lg"
      centered
      backdrop="static"
      keyboard={false}
      className="mcp-modal"
    >
      <Modal.Header>
        <Modal.Title>API Key Created</Modal.Title>
      </Modal.Header>
      <Modal.Body className="mcp-modal-body">
        {/* Warning banner */}
        <div className="mcp-warning-banner">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            className="mcp-warning-icon"
          >
            <path
              d="M10 2L1 18h18L10 2zm0 4v6m0 2v2"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Save this key now — you won't see it again</span>
        </div>

        {/* Key display */}
        <div className="mcp-key-display">
          <label className="mcp-field-label">Your API key</label>
          <div className="mcp-key-box">
            <code className="mcp-key-value">{apiKey}</code>
          </div>
          <div className="mcp-key-meta">
            <span>
              Name: <strong>{name}</strong>
            </span>
            <span>
              Wallet: #{walletIndex} ({truncateAddress(walletAddress)})
            </span>
          </div>
          <CopyButton text={apiKey} label="Copy key" className="mcp-btn-block" />
        </div>

        {/* Config JSON */}
        <div className="mcp-config-display">
          <label className="mcp-field-label">
            Claude Desktop config (claude_desktop_config.json)
          </label>
          <pre className="mcp-code-block">{configJson}</pre>
          <CopyButton
            text={configJson}
            label="Copy config"
            className="mcp-btn-block"
          />
        </div>
      </Modal.Body>
      <Modal.Footer className="mcp-modal-footer">
        <button type="button" className="fugu--btn mcp-btn-primary" onClick={onClose}>
          <span>I've saved my key</span>
        </button>
      </Modal.Footer>
    </Modal>
  );
}
